import $foreign from "./foreign.cjs";
var begin = $foreign.begin;
var enabled = $foreign.enabled;
var end = $foreign.end;
var none = $foreign.none;
export { begin, enabled, end, none };
